export enum WriteOffGoodsOperationTypeEnum {
    WriteOffSpendingMaterial = 0,
    TaxableWriteOff = 1,
    WriteOffWithPayment = 2
}